import { UI_NewsList } from 'ui/components/3-organisms/NewsList/NewsList';
import { usePageContext } from '3-foundation/PageContent/PageContext';
import { getNews } from '3-foundation/News/repository';
import useSWR from 'swr';
import { NewsCardProps } from 'ui/components/2-molecules/Card/NewsCard/NewsCard';

interface Props {
	documentType: 'newsList';
	content: {
		properties: {
			rootFolder: Content.Page | null;
			link: Content.Link | null;
			isTeaserList: boolean;
			teaserHeading: string | null;
			columns: '2' | '3' | '4';
		};
	};
}

export const NewsList = ({ content }: Props) => {
	const context = usePageContext();
	const { rootFolder, isTeaserList = true, link, teaserHeading, columns } = content?.properties ?? {};
	const { id: rootFolderId } = rootFolder ?? {};

	const rootId = rootFolderId ? rootFolderId : 0;
	const limitQuery = isTeaserList ? Number(columns) || 4 : null;
	const offsetQuery = null;

	const fetcher = () => getNews({ rootId: Number(rootId), limit: limitQuery, offset: offsetQuery });
	const { data, isLoading } = useSWR([rootId, limitQuery, offsetQuery, context.preview, context.previewData], fetcher, {
		revalidateOnFocus: false,
	});
	const mappedResults =
		data
			?.sort((a, b) => {
				const dateA = new Date(a.date).getTime();
				const dateB = new Date(b.date).getTime();
				return dateB - dateA; // Sort in descending order (latest first)
			})
			.map((item): NewsCardProps => {
				return {
					heading: item.heading,
					url: item.url,
					kicker: item.kicker,
					text: item.text,
					date: item?.date,
					image: item.image,
				};
			}) ?? [];

	return (
		<UI_NewsList
			link={link}
			isTeaserList={isTeaserList}
			teaserHeading={teaserHeading}
			newsResult={isLoading || !data ? { articles: null, isLoading: true } : { articles: mappedResults, isLoading: isLoading }}
			columns={columns || '4'}
		/>
	);
};
